module.exports = __webpack_public_path__ + "static/media/about-hero-2.e091fc47.png";